import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
export default {
  name: 'TheCart',
  data: function data() {
    return {
      couponCode: null,
      shopLink: null
    };
  },
  fetch: function fetch() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $swell;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Set component data
              $swell = _this.$swell;
              _context.next = 3;
              return $swell.settings.get('cart.shopLink', '/categories/');

            case 3:
              _this.shopLink = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState(['cart', 'cartIsUpdating', 'currency'])), {}, {
    account: function account() {
      if (!this.cart.account) return;
      return this.cart.account;
    }
  }),
  mounted: function mounted() {
    // TODO: init query
    // Pass a checkout ID as a query string param to recover a specific cart
    var checkoutId = this.$route.query.checkout;
    this.$store.dispatch('initializeCart', {
      checkoutId: checkoutId
    });
  },
  methods: {
    closeCart: function closeCart() {
      this.$store.commit('setState', {
        key: 'cartIsActive',
        value: false
      });
    },
    applyDiscount: function applyDiscount() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('applyDiscount', _this2.couponCode);

              case 2:
                // Reset the coupon input
                _this2.couponCode = null;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    removeDiscount: function removeDiscount(id) {
      this.$store.dispatch('removeDiscount', id);
    }
  }
};